import { fetch_sadap } from "../../core/api";

export const WorkUnitGetList = (data) => {
	return fetch_sadap("employee-biodata/workunit/list", "get", data, false);
};

export const WorkUnitGetListByLevel = () => {
	return fetch_sadap(`employee-biodata/workunit/list/by-level`, "post", {
		"list_level_id" : [3,5]
	}, false);
};
